import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

import './style.css';
import waitingIcon from './svg/rollout-waiting-icon.svg';
import runningIcon from './svg/rollout-running-icon.svg';
import abortedIcon from './svg/rollout-aborted-icon.svg';
import pausedIcon from './svg/rollout-paused-icon.svg';
import pendingIcon from './svg/task-pending-icon.svg';
import userIcon from './svg/user-icon.svg';
import copyIcon from './svg/copy-icon.svg';
import deviceRolloutIcon from './svg/device-rollout-icon.svg';
import linkIcon from './svg/link-icon.svg';
import trashIcon from './svg/trash-icon.svg';
import fileIcon from './svg/file-icon.svg';
import deviceIcon from './svg/device-icon.svg';
import account from './svg/account.svg';
import externalLink from './svg/external-link.svg';
import apiKey from './svg/api-key.svg';
import exiticon from './svg/exit-icon.svg';
import settingsicon from './svg/settings-icon.svg';
import disableIcon from './svg/disable.svg';
import enableIcon from './svg/enable.svg';
import unrecognized from './svg/unrecognized-icon.svg';
import productSettings from './svg/product-settings.svg';
import billing from './svg/billing.svg';
import billingWarningIcon from './svg/warning-yellow.svg';
import billingBlockedIcon from './svg/warning-blocked.svg';
import checkSuccessIcon from './svg/check-success.svg';
import loadingIcon from './svg/loading.svg';
import checkBadge from './svg/check-badge.svg';
import clockGrey from './svg/clock-grey.svg';
import emptyTable from './svg/empty-table.svg';

const smallIconStyle = {
  height: 15,
  marginBottom: -3,
};

export const EmptyTable = props => (
  <img src={emptyTable} alt="table" {...props} />
);

export const Download = props => (
  <svg width={16} height={16} {...props}>
    <path d="M 7,14 C 3.1340067,14 0,10.865993 0,7 0,3.1340067 3.1340067,0 7,0 c 3.865993,0 7,3.1340067 7,7 0,3.865993 -3.134007,7 -7,7 z m 0,-1 c 3.313709,0 6,-2.686291 6,-6 C 13,3.6862915 10.313709,1 7,1 3.6862915,1 1,3.6862915 1,7 c 0,3.313709 2.6862915,6 6,6 z" />
    <path d="m 6.5,2 v 8 h 1 V 2 Z" />
    <path d="M 4.0976562,6.640625 3.4023438,7.359375 7,10.839844 10.597656,7.359375 9.902344,6.640625 7,9.449219 Z" />
  </svg>
);

export const ClockGrey = props => (
  <img src={clockGrey} alt="clock" {...props} />
);

export const CheckBadge = props => (
  <img src={checkBadge} alt="check" {...props} />
);

export const LoadingIcon = props => (
  <img src={loadingIcon} className="rotating" alt="loading" {...props} />
);

export const CheckSuccessIcon = props => (
  <img src={checkSuccessIcon} alt="Check Success" {...props} />
);

export const BillingBlockedIcon = props => (
  <img src={billingBlockedIcon} alt="Billing Blocked" {...props} />
);

export const BillingWarningIcon = props => (
  <img src={billingWarningIcon} alt="Billing Warning" {...props} />
);

export const BillingIcon = props => (
  <img src={billing} alt="Billing icon" {...props} />
);

export const ProductSettingsIcons = props => (
  <img src={productSettings} alt="Product Settings" {...props} />
);

export const EnableIcon = props => (
  <img src={enableIcon} alt="Enable icon" {...props} />
);

export const Unrecognized = props => (
  <img src={unrecognized} alt="Unrecognized icon" {...props} />
);

export const DisableIcon = props => (
  <img src={disableIcon} alt="Disable icon" {...props} />
);

export const SettingsIcon = props => (
  <img src={settingsicon} alt="Settings icon" {...props} />
);

export const ExitIcon = props => (
  <img src={exiticon} alt="Exit icon" {...props} />
);

export const ApiKeysIcon = props => (
  <img src={apiKey} alt="Api key icon" {...props} />
);

export const ExternalLinkIcon = () => <img src={externalLink} alt="External" />;

export const AccountIcon = props => (
  <img src={account} alt="Account icon" {...props} />
);

export const DeviceIcon = () => <img src={deviceIcon} alt="total devices" />;

export { default as YellowCorner } from './svg/yellow-corner.svg';

export { default as RedCorner } from './svg/red-corner.svg';

export { default as ProductIcon } from './svg/empty-product.svg';

export const FileIconPackage = props => (
  <img src={fileIcon} alt="file" {...props} />
);

export const TrashIconPackage = () => <img src={trashIcon} alt="trash icon" />;

export const LinkIcon = props => (
  <img src={linkIcon} alt="link icon" {...props} />
);

export { default as WaitingStatusIcon } from './svg/waiting-status-icon.svg';

export { default as RunningStatusIcon } from './svg/running-status-icon.svg';

export { default as PendingStatusIcon } from './svg/pending-status-icon.svg';

export { default as DeviceCompletedIcon } from './svg/device-complete-icon.svg';

export { default as DeviceErrorIcon } from './svg/device-error-icon.svg';

export { default as DeviceRunningIcon } from './svg/device-running-icon.svg';

export const DeviceRolloutIcon = props => (
  <img src={deviceRolloutIcon} alt="rolloutIcon" {...props} />
);

export const CopyIcon = props => (
  <img src={copyIcon} alt="Copy it" {...props} />
);

export const RunningIcon = () => (
  <img className="uh-spin" src={runningIcon} alt="running" />
);

export const RunningIconSmall = () => (
  <img
    className="uh-spin"
    style={smallIconStyle}
    src={runningIcon}
    alt="running"
  />
);

export const PausedIcon = () => <img src={pausedIcon} alt="paused" />;

export const AbortedIcon = props => (
  <img src={abortedIcon} alt="aborted" {...props} />
);

export const WaitingIcon = props => (
  <img src={waitingIcon} alt="waiting" {...props} />
);

export const PendingIcon = props => (
  <img src={pendingIcon} alt="pending" {...props} />
);

export const StartIcon = props => (
  /* eslint-disable max-len */
  <svg width={16} height={16} {...props}>
    <path d="M6.4,11.6 L11.2,8 L6.4,4.4 L6.4,11.6 Z M8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 C16,3.6 12.4,0 8,0 Z M8,14.4 C4.48,14.4 1.6,11.52 1.6,8 C1.6,4.48 4.48,1.6 8,1.6 C11.52,1.6 14.4,4.48 14.4,8 C14.4,11.52 11.52,14.4 8,14.4 Z" />
  </svg>
);

export const ArchiveIcon = props => (
  /* eslint-disable max-len */
  <svg width={16} height={16} {...props}>
    <path d="M 4.1402776,1.3207345 A 0.60006002,0.60006002 0 0 0 3.6383245,1.5922189 L 1.302387,5.1586251 a 0.60006002,0.60006002 0 1 0 1.0039062,0.65625 L 4.4644963,2.5199533 h 7.0703127 l 2.158203,3.2949218 a 0.60006002,0.60006002 0 1 0 1.003906,-0.65625 L 12.360981,1.5922189 A 0.60006002,0.60006002 0 0 0 11.859028,1.3207345 Z" />
    <path d="M 1.8046875,5.3203125 A 0.60006002,0.60006002 0 0 0 1.2050781,5.9199219 v 6.7968751 c 0,0.879184 0.7197904,1.607422 1.5996094,1.607422 H 13.195312 c 0.879781,0 1.59961,-0.728216 1.59961,-1.607422 V 5.9199219 A 0.60006002,0.60006002 0 0 0 14.195312,5.3203125 H 10.277344 A 0.60006002,0.60006002 0 0 0 9.6777344,5.9199219 V 7.15625 c 0,0.1805723 -0.1307516,0.3105469 -0.3046875,0.3105469 H 6.6269531 c -0.1738488,0 -0.3046875,-0.1299736 -0.3046875,-0.3105469 V 5.9199219 A 0.60006002,0.60006002 0 0 0 5.7226562,5.3203125 Z M 2.4042969,6.5195312 H 5.1210938 V 7.15625 c 0,0.8252817 0.6797381,1.5097656 1.5058593,1.5097656 h 2.7460938 c 0.8261391,0 1.5058591,-0.6844829 1.5058591,-1.5097656 V 6.5195312 h 2.716797 v 6.1972658 c 0,0.228509 -0.178957,0.40625 -0.400391,0.40625 H 2.8046875 c -0.221395,0 -0.4003906,-0.177825 -0.4003906,-0.40625 z" />
  </svg>
);

export const PauseIconRollout = props => (
  <svg width={13} height={13} {...props}>
    <rect height="9" width="2" y="4.161016" x="3.9999995" />
    <rect height="9" width="2" y="4.161016" x="10.000001" />
  </svg>
);

export const PauseIcon = props => (
  <svg width={16} height={16} {...props}>
    <rect height="10" width="2" y="3.161016" x="3.9999995" />
    <rect height="10" width="2" y="3.161016" x="10.000001" />
  </svg>
);

export const CheckIcon = props => (
  /* eslint-disable max-len */
  <svg width={16} height={16} {...props}>
    <path d="M 1.9815573,8.1475407 6.4077868,12.573771 14.018443,4.9631147 12.481557,3.4262295 6.3709015,9.5368857 3.4815574,6.6475407 Z" />
  </svg>
);

export const AddIcon = props => (
  <svg width={16} height={16} {...props}>
    <path d="M 7,7.0000001 H 3 v 2 H 7 V 13 H 9 V 9.0000001 h 4 v -2 H 9 v -4 H 7 Z" />
  </svg>
);

export const CogIcon = props => (
  <svg width={16} height={16} {...props}>
    <path d="M 6.5253906,0.5 C 6.2897846,0.5 6.1422488,0.57755601 5.9960938,0.68554688 5.8499387,0.79353774 5.6699219,0.95713531 5.6699219,1.28125 l 0.00391,-0.074219 -0.25,1.671875 C 5.1409536,3.0154122 4.8747251,3.1650059 4.6347656,3.3300781 L 3.1464844,2.71875 A 0.50005,0.50005 0 0 0 3.1113281,2.7050781 C 2.9259822,2.6442121 2.7080811,2.6366303 2.5234375,2.6972656 2.3387939,2.757901 2.2065578,2.8652534 2.1054688,2.9648438 A 0.50005,0.50005 0 0 0 2.0234375,3.0703125 L 0.59570312,5.5332031 0.67578125,5.4277344 C 0.53921004,5.5622783 0.5040393,5.7263902 0.5,5.8417969 0.4959607,5.9572036 0.5171173,6.0467291 0.54492188,6.1289062 0.60053102,6.2932605 0.68954319,6.43367 0.8203125,6.5625 a 0.50005,0.50005 0 0 0 0.0507813,0.042969 L 2.1464844,7.5644531 c -0.021157,0.1271406 -0.046875,0.2257006 -0.046875,0.4707031 0,0.1547466 0.039069,0.3172442 0.054687,0.4746094 L 0.859375,9.5429688 A 0.50005,0.50005 0 0 0 0.8203125,9.578125 c -0.13076824,0.1288287 -0.23707465,0.3096752 -0.26171875,0.503906 -0.0246441,0.194231 0.0276025,0.371622 0.09375,0.501953 a 0.50005,0.50005 0 0 0 0.0136719,0.02344 l 1.42968748,2.46289 a 0.50005,0.50005 0 0 0 0.080078,0.105469 c 0.1901239,0.187302 0.5648531,0.311188 0.9355469,0.189453 a 0.50005,0.50005 0 0 0 0.027344,-0.0098 l 1.5664062,-0.619141 c 0.2617938,0.174599 0.5267244,0.330134 0.7929688,0.462891 l 0.2480469,1.595703 -0.00586,-0.07617 c 0,0.479054 0.4242621,0.78125 0.8574218,0.78125 H 9.453125 c 0.2356061,0 0.3831418,-0.07756 0.5292969,-0.185547 0.1461551,-0.107991 0.3281251,-0.271588 0.3281251,-0.595703 l -0.0059,0.07617 0.248046,-1.59375 c 0.266696,-0.132941 0.532624,-0.288039 0.794922,-0.462891 l 1.564453,0.617188 -0.03711,-0.01758 c 0.219576,0.108156 0.432545,0.09579 0.617188,0.03516 0.184642,-0.06063 0.366707,-0.178136 0.478515,-0.398438 l 1.414063,-2.4375 a 0.50005,0.50005 0 0 0 0.01367,-0.02344 c 0.08137,-0.160321 0.117572,-0.327576 0.0957,-0.5214845 -0.02187,-0.1939086 -0.143367,-0.4534123 -0.392579,-0.5761719 l 0.0625,0.035156 -1.40039,-0.9589844 c 0.02112,-0.1268885 0.04687,-0.2191404 0.04687,-0.4570313 0,-0.1553751 -0.03886,-0.3185215 -0.05469,-0.4765624 l 1.294922,-1.03125 a 0.50005,0.50005 0 0 0 0.03906,-0.035156 c 0.130768,-0.1288291 0.235121,-0.3096764 0.259765,-0.5039063 0.02464,-0.1942298 -0.0276,-0.3716215 -0.09375,-0.5019531 a 0.50005,0.50005 0 0 0 -0.01367,-0.023437 L 13.814453,3 A 0.50005,0.50005 0 0 0 13.732422,2.8945312 C 13.542294,2.7072202 13.167567,2.583347 12.796875,2.7050781 a 0.50005,0.50005 0 0 0 -0.02734,0.00977 L 11.205078,3.3339844 C 10.94226,3.1585899 10.677441,3.0023796 10.410156,2.8691406 l -0.248047,-1.59375 -0.01953,0.2363282 C 10.237745,1.2304486 10.121271,0.90203899 9.9570312,0.74023438 9.7927917,0.57842976 9.6184186,0.5 9.3828125,0.5 Z m 0.1171875,1 H 9.1855469 L 9.4589844,3.2578125 A 0.50005,0.50005 0 0 0 9.7324219,3.6289062 C 10.160886,3.8399615 10.559594,4.041076 10.859375,4.2773438 a 0.50005,0.50005 0 0 0 0.492187,0.072266 l 1.701172,-0.6699219 1.251954,2.1601563 -1.376954,1.1015624 a 0.50005,0.50005 0 0 0 -0.162109,0.5507813 c 0.03898,0.1151953 0.04492,0.2615618 0.04492,0.5429687 0,0.1968202 -0.07227,0.3792874 -0.07227,0.703125 a 0.50005,0.50005 0 0 0 0.21875,0.4121094 l 1.484375,1.0195314 -1.279297,2.207031 -1.667968,-0.65625 a 0.50005,0.50005 0 0 0 -0.492188,0.07227 C 10.702174,12.029236 10.303464,12.230351 9.875,12.441406 A 0.50005,0.50005 0 0 0 9.6035156,12.8125 L 9.3378906,14.5 h -2.625 L 6.4492188,12.8125 A 0.50005,0.50005 0 0 0 6.1757812,12.441406 c -0.4284639,-0.211055 -0.8252208,-0.41217 -1.125,-0.648437 A 0.50005,0.50005 0 0 0 4.5585938,11.720703 L 2.8554688,12.390625 1.6035156,10.230469 2.9824219,9.1289062 A 0.50005,0.50005 0 0 0 3.1445312,8.578125 C 3.105555,8.4629293 3.0996094,8.3165633 3.0996094,8.0351562 c 0,-0.1968202 0.070312,-0.3792873 0.070312,-0.703125 A 0.50005,0.50005 0 0 0 2.9707031,6.9316406 L 1.5566406,5.8710938 2.8320312,3.6699219 4.4804688,4.3476562 A 0.50005,0.50005 0 0 0 4.9433594,4.3027344 C 5.3931307,4.0073333 5.7201204,3.7609876 6.0390625,3.65625 A 0.50005,0.50005 0 0 0 6.3789062,3.2558594 Z m 1.3125,3.5722656 c -1.637575,0 -3,1.3622255 -3,3 0,1.6377745 1.362425,3.0000004 3,3.0000004 1.6375742,0 2.9980469,-1.3622258 2.9980469,-3.0000004 0,-1.6377746 -1.3604726,-3 -2.9980469,-3 z m 0,1 c 1.0760298,0 1.9980469,0.9234884 1.9980469,2 0,1.0765115 -0.9220171,2.0000004 -1.9980469,2.0000004 -1.076031,0 -2,-0.9234888 -2,-2.0000004 0,-1.0765117 0.9239691,-2 2,-2 z" />
  </svg>
);

export const LessIcon = props => (
  <svg width={16} height={16} {...props}>
    <polygon
      points="8,6 1.5135135,12 0,10.5 4.972973,6 0,1.4 1.5135135,0"
      transform="matrix(-1,0,0,1,12,2)"
    />
  </svg>
);

export const TrashIcon = props => (
  <svg width={16} height={16} {...props}>
    <path d="m 2.3505936,2.821084 0.037109,0.5371094 0.8378907,11.6015626 h 9.5488284 l 0.875,-12.138672 z m 1.0742187,1 H 12.575203 L 11.844734,13.959756 H 4.155281 Z" />
    <path d="m 1.6933594,2.5097656 v 1 H 14.306641 v -1 z" />
    <path d="m 6.3320312,1.0410156 -0.9023437,2.78125 h 0.6875 4.4531245 l -0.9023432,-2.78125 z m 0.7265626,1 h 1.8828124 l 0.2539063,0.78125 h -2.390625 z" />
    <path d="m 7.5058594,5.109375 v 7.517578 h 1 V 5.109375 Z" />
    <path d="m 10.164062,5.078125 -0.4980464,7.515625 0.9960934,0.06641 0.498047,-7.5175779 z" />
    <path d="M 5.8476562,5.078125 4.8496094,5.1425781 5.3476562,12.660156 6.3457031,12.59375 Z" />
  </svg>
);

export const LeaveIcon = props => (
  <svg width={16} height={16} {...props}>
    <path d="M 3,1.5 C 2.1774953,1.5 1.5,2.1774951 1.5,3 v 10 c 0,0.822505 0.6774953,1.5 1.5,1.5 h 6 c 0.8225046,0 1.5,-0.677495 1.5,-1.5 v -2 h -1 v 2 c 0,0.282065 -0.2179352,0.5 -0.5,0.5 H 3 C 2.7179351,13.5 2.5,13.282065 2.5,13 V 3 C 2.5,2.7179349 2.7179351,2.5 3,2.5 h 6 c 0.2820648,0 0.5,0.217935 0.5,0.5 v 2 h 1 V 3 C 10.5,2.177495 9.8225046,1.5 9,1.5 Z" />
    <path d="m 12.149676,4.1434998 -0.707106,0.7071068 0.353553,0.3535534 2.75385,2.7538496 -2.796663,2.7966624 -0.353553,0.353553 0.707107,0.707107 0.353553,-0.353553 3.150216,-3.150216 a 0.50005,0.50005 0 0 0 0,-0.7071068 L 12.50323,4.4970532 Z" />
    <path d="m 5,7.5 v 1 h 10 v -1 z" />
  </svg>
);

export const UserIcon = () => <img src={userIcon} alt="icon" />;

export const DevicesIcon = props => (
  <SvgIcon {...props}>
    <path d="m 6.1660155,4.0000001 c -0.5943677,0 -1.1660154,0.3763928 -1.1660154,1 V 21 c 0,0.623607 0.5716477,1 1.1660155,1 H 17.833984 C 18.428352,22 19,21.623607 19,21 V 5.0000001 c 0,-0.6236073 -0.571648,-1 -1.166016,-1 z m -0.1660154,1 c 0,0.1084748 -0.00727,0 0.1660155,0 H 17.833984 c 0.173287,0 0.166016,0.1084748 0.166016,0 V 21 c 0,-0.108475 0.0073,0 -0.166016,0 H 6.1660155 C 5.9927292,21 6.0000001,20.891525 6.0000001,21 Z m 1,2.5 a 0.50005,0.50005 0 1 0 0,1 H 17 a 0.50005,0.50005 0 1 0 0,-1 z M 10,18.5 a 0.50005,0.50005 0 1 0 0,1 h 4 a 0.50005,0.50005 0 1 0 0,-1 z" />
  </SvgIcon>
);

export const OverviewIcon = props => (
  <SvgIcon {...props}>
    <path d="M 11.21875 -0.033203125 C 9.9928454 -0.033203125 8.9824219 0.92301737 8.9824219 2.0839844 L 8.9824219 21.847656 C 8.9824219 23.008622 9.9928454 23.966797 11.21875 23.966797 L 12.708984 23.966797 C 13.934888 23.966797 14.945312 23.008622 14.945312 21.847656 L 14.945312 2.0839844 C 14.945312 0.92301737 13.934888 -0.033203125 12.708984 -0.033203125 L 11.21875 -0.033203125 z M 11.21875 1.3769531 L 12.708984 1.3769531 C 13.13481 1.3769531 13.455078 1.6807164 13.455078 2.0839844 L 13.455078 21.847656 C 13.455078 22.250925 13.13481 22.554688 12.708984 22.554688 L 11.21875 22.554688 C 10.792924 22.554688 10.472656 22.250925 10.472656 21.847656 L 10.472656 2.0839844 C 10.472656 1.6807164 10.792924 1.3769531 11.21875 1.3769531 z M 20.162109 8.8222656 C 18.936205 8.8222656 17.927734 9.848376 17.927734 11.09375 L 17.927734 21.695312 C 17.927734 22.940687 18.936205 23.966797 20.162109 23.966797 L 21.654297 23.966797 C 22.880201 23.966797 23.890625 22.940686 23.890625 21.695312 L 23.890625 11.09375 C 23.890625 9.848376 22.880201 8.8222656 21.654297 8.8222656 L 20.162109 8.8222656 z M 20.162109 10.335938 L 21.654297 10.335938 C 22.080122 10.335938 22.398438 10.661161 22.398438 11.09375 L 22.398438 21.695312 C 22.398438 22.127902 22.080122 22.451172 21.654297 22.451172 L 20.162109 22.451172 C 19.736283 22.451172 19.417969 22.127901 19.417969 21.695312 L 19.417969 11.09375 C 19.417969 10.661161 19.736283 10.335937 20.162109 10.335938 z M 2.2734375 16.263672 C 1.0475328 16.263672 0.0390625 17.133638 0.0390625 18.189453 L 0.0390625 22.041016 C 0.0390625 23.096831 1.0475328 23.966797 2.2734375 23.966797 L 3.765625 23.966797 C 4.9915297 23.966797 6.0019531 23.096831 6.0019531 22.041016 L 6.0019531 18.189453 C 6.0019531 17.133638 4.9915297 16.263672 3.765625 16.263672 L 2.2734375 16.263672 z M 2.2734375 17.546875 L 3.765625 17.546875 C 4.1914502 17.546875 4.5097656 17.822708 4.5097656 18.189453 L 4.5097656 22.041016 C 4.5097656 22.40776 4.1914502 22.681641 3.765625 22.681641 L 2.2734375 22.681641 C 1.8476123 22.681641 1.5292969 22.40776 1.5292969 22.041016 L 1.5292969 18.189453 C 1.5292969 17.822708 1.8476123 17.546875 2.2734375 17.546875 z" />
  </SvgIcon>
);

export const PackagesIcon = props => (
  <SvgIcon {...props}>
    <path d="M 2.6660156 2 C 1.2027819 2 2.9605947e-16 3.2027819 0 4.6660156 L 0 19.333984 C 0 20.797219 1.2027822 22 2.6660156 22 L 21.333984 22 C 22.797218 22 24 20.797218 24 19.333984 L 24 7.3339844 C 24 5.8707509 22.797219 4.6660156 21.333984 4.6660156 L 12 4.6660156 L 9.3339844 2 L 9.0566406 2 L 2.6660156 2 z M 2.6660156 3.3339844 L 8.78125 3.3339844 L 11.447266 6 L 21.333984 6 C 22.067704 6 22.666016 6.6002643 22.666016 7.3339844 L 22.666016 19.333984 C 22.666016 20.067706 22.067706 20.666016 21.333984 20.666016 L 2.6660156 20.666016 C 1.9322955 20.666016 1.3339844 20.067704 1.3339844 19.333984 L 1.3339844 4.6660156 C 1.3339844 3.9322958 1.9322958 3.3339844 2.6660156 3.3339844 z " />
  </SvgIcon>
);

export const RolloutsIcon = props => (
  <SvgIcon {...props}>
    <path d="m 10.921719,2.2956659 a 0.54916051,0.54916051 0 0 0 -0.56412,0.5491056 v 2.3186833 l -2.8935246,0.00648 C 5.8360502,5.089128 4.1070599,5.6729633 2.7087336,6.7378887 1.3104057,7.8028141 0.23820928,9.3743713 0.03827768,11.276588 -0.35617684,15.029576 2.3430214,18.407872 6.0634257,18.79891 A 0.54916051,0.54916051 0 1 0 6.1771071,17.707131 C 3.0537543,17.378855 0.79693408,14.561847 1.1300547,11.392415 1.2939111,9.8334227 2.1731129,8.5251868 3.3736652,7.6108803 4.5742177,6.6965743 6.0886785,6.2025423 7.4104502,6.2681461 h 0.015016 l 2.9321428,-0.00648 V 8.552453 a 0.54916051,0.54916051 0 0 0 0.834389,0.4697418 l 4.703846,-2.85492 a 0.54916051,0.54916051 0 0 0 0,-0.9373408 L 11.191991,2.3750368 a 0.54916051,0.54916051 0 0 0 -0.27027,-0.079368 z m 0.534097,1.5229105 3.097299,1.8789701 -3.097299,1.8811165 z m 6.505613,1.6280125 a 0.54916051,0.54916051 0 0 0 -0.04075,1.0960662 c 3.117143,0.3827381 5.326031,3.2373769 4.937652,6.4005119 -0.191043,1.5559 -1.09378,2.847573 -2.310102,3.74078 -1.216329,0.893215 -2.739939,1.362756 -4.060385,1.274097 l -0.01081,-0.0024 -2.788422,-0.07508 0.04292,-2.42594 A 0.54916051,0.54916051 0 0 0 12.90573,14.972079 l -4.7532001,2.771249 a 0.54916051,0.54916051 0 0 0 -0.015018,0.939479 l 4.6523941,2.936485 a 0.54916051,0.54916051 0 0 0 0.842955,-0.454718 l 0.03864,-2.185698 2.764827,0.07716 -0.02144,-0.0024 c 1.626368,0.109205 3.36652,-0.443945 4.783223,-1.484305 1.41672,-1.040218 2.516744,-2.592935 2.749843,-4.491368 C 24.407838,9.3327356 21.768792,5.9088952 18.05578,5.4529947 a 0.54916051,0.54916051 0 0 0 -0.09438,-0.00649 z m -5.343054,10.9649511 -0.03215,1.818908 a 0.54937798,0.54937798 0 0 0 -0.0066,0.353924 l -0.02792,1.585106 -3.0629783,-1.932594 z" />
  </SvgIcon>
);

export const BackIcon = props => (
  <SvgIcon {...props}>
    <path d="M 11.779297,0.22167918 2.0746619e-8,12.000977 11.775392,23.778321 13.343751,22.209962 4.2324222,13.098633 H 24 v -2.21289 H 4.246094 l 9.097657,-9.0996105 z" />
  </SvgIcon>
);

export const WarningIcon = props => (
  <SvgIcon {...props}>
    <path d="M 0,22.4 H 24 L 12,1.6 Z M 12.914286,18.933333 H 11.2 V 17.2 h 1.714286 z m 0,-3.466666 H 11.2 v -5.2 h 1.714286 z" />
  </SvgIcon>
);

export const ArrowRight = props => (
  <SvgIcon {...props}>
    <path d="m 15.535534,11.292893 v 1.414214 L 14.828427,12 Z M 14.828427,12 7.7573593,4.9289324 V 3.5147188 L 16.242641,12 7.7573593,20.485281 v -1.414213 z m 0,0 0.707107,-0.707107 v 1.414214 z m 0,0 L 7.7573593,4.9289324 V 3.5147188 L 16.242641,12 7.7573593,20.485281 v -1.414213 z" />
  </SvgIcon>
);
